
export class UserLogged { 
    cnpj: string;
    userType: string;
}